var map = {
	"./amex-1kpx.png": 75652,
	"./amex.png": 8474,
	"./brands/amex.png": 22020,
	"./brands/discover.png": 54516,
	"./brands/mastercard.png": 13255,
	"./brands/troy.png": 34687,
	"./brands/visa.png": 13943,
	"./card/amex.png": 10203,
	"./card/brands/amex.png": 62725,
	"./card/brands/discover.png": 88357,
	"./card/brands/mastercard.png": 28712,
	"./card/brands/troy.png": 30074,
	"./card/brands/visa.png": 64037,
	"./card/chip.png": 75122,
	"./card/dinersclub.png": 45093,
	"./card/discover.png": 37862,
	"./card/jcb.png": 38298,
	"./card/mastercard.png": 63856,
	"./card/troy.png": 24588,
	"./card/unionpay.png": 50927,
	"./card/visa.png": 23395,
	"./chip.png": 98215,
	"./dinersclub.png": 92859,
	"./discover-1kpx.png": 35949,
	"./discover.png": 6559,
	"./footer/boleto-barcode.svg": 85899,
	"./footer/diners.svg": 51214,
	"./footer/elo.svg": 3256,
	"./footer/hipercard-v2.svg": 59126,
	"./footer/mastercard.svg": 79788,
	"./footer/visa.svg": 3438,
	"./jcb.png": 65353,
	"./logo.png": 95847,
	"./mastercard-1kpx.png": 5659,
	"./mastercard.png": 47677,
	"./troy-1kpx.png": 9440,
	"./troy.png": 38523,
	"./unionpay.png": 80057,
	"./visa-1kpx.png": 91397,
	"./visa.png": 54201
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49517;